<template>
	<section class="min-h-svh flex flex-col items-center justify-center">
		<img src="/logos/planets-logo.png" alt="logo" class="h-20 absolute top-20" />

		<template v-if="reloading">
			<Icon name="svg-spinners:180-ring" class="text-4xl text-gray-400 mb-4" />
			<p class="text-xl text-gray-500">Načítavam novú verziu adminky…</p>
		</template>

		<template v-else>
			<h1 class="text-5xl font-bold mb-3">{{ error.statusCode }}</h1>

			<p class="text-xl text-gray-500 mb-8">
				{{ error.message }}
			</p>

			<Button @click="handleError"> Späť domov </Button>
		</template>
	</section>
</template>

<script setup>
const { error } = defineProps({
	error: Object
})

// Chýbajúci JS súbor starej verzie po nasadení. Namiesto 500 stránku obnovíme;
// značka v sessionStorage bráni slučke, keby súbor chýbal aj po obnovení.
// Pri navigácii Nuxt sám obnoví rovno cieľovú adresu, preto čakáme chvíľu
// a vlastné obnovenie je len záloha (napr. pre komponent načítaný neskôr).
const CHUNK_ERROR = /dynamically imported module|Importing a module script failed|Failed to fetch|Loading (CSS )?chunk|error loading dynamically/i
const RELOAD_KEY = 'boxy:chunk-reload'

const reloading = ref(false)

if (import.meta.client && CHUNK_ERROR.test(error?.message || '')) {
	let last = 0
	try {
		last = Number(sessionStorage.getItem(RELOAD_KEY)) || 0
	} catch {}
	if (Date.now() - last > 60 * 1000) {
		reloading.value = true
		try {
			sessionStorage.setItem(RELOAD_KEY, String(Date.now()))
		} catch {}
		setTimeout(() => window.location.reload(), 1500)
	}
}

const handleError = () => clearError({ redirect: '/' })
</script>
